import type { ICrmOperationEvent } from "@core/Models/autogenerated/operation.models";
import { IBulkUpdateResult } from "./BulkUpdateApi";

export enum EventStreamFetchStatus
{
    FullCompletion,
    PartialCompletion
}

export interface IEventStreamFetchResult
{
    events: ICrmOperationEvent[];
    status: EventStreamFetchStatus;
    nextCursor: any;
}

export interface IEventStream {
    add(event: ICrmOperationEvent): Promise<void>;
    addRange(events: ICrmOperationEvent[]): Promise<IBulkUpdateResult>;
    fetch(cursor: any | null, limit: number): Promise<IEventStreamFetchResult>;
    process(): Promise<void>;
}
